import { Config as PackageInternalConfig } from '@hugendubel/react-ws';
import { WsBonusShopCustomerData } from './ws/result/WsBonusShopCustomerData';

export const _Config = { initDone: false };

type Properties = Readonly<{
    mediaBaseUrl: string;
    giftWrapCosts: any;
    giftWrapPriceHint: any;
    pickupProperties: any;
    tolinoResellerId: any;
    webreaderBaseUrl: any;
    payAndCollectEnabled: any;
    showPromisedDeliveryDate: any;
    giftWrapEnabled: any;
}>;
type WsInitResult = Readonly<{
    hugendubel?: boolean;
    orderSystemCode: string;
    properties: Properties;
}>;

type ConfigType = Readonly<{
    mediaBaseUrl: string;
    isPhysicalBookstore: boolean;
    customerData: WsBonusShopCustomerData;
}>;

/**
 * Initial values only to ensure type consistency. Should be used nowhere.
 * As soon as "Config.init" gets called all values will be initialized correctly.
 */
let _config: ConfigType | void = undefined;

/**
 * It is very important that the method gets called with the complete config.
 * And for now this will happen only once in application time. Right before
 * rendering starts and right after the initialization call returned the required
 * information. See {@link InitService}.
 */
const init = (config: ConfigType): void => {
    _config = config;
    _Config.initDone = true;
    // Since some package updates where needed here and the mediaBaseUrl is also needed in the package internal config
    // for the CoverImg component for instance, we have to set a minimal PackageInternalConfig here.
    // TODO: This has to be refactored in a port or package refactor of the bonus shop.
    PackageInternalConfig.init({
        hugendubel: true,
        orderSystemCode: '',
        properties: {
            mediaBaseUrl: config.mediaBaseUrl,
        },
    } as WsInitResult);
};

const get = (): ConfigType => _config as any;

const initDone = () => _Config.initDone;

export const Config = { init, get, initDone };
